import { SupportTicketUrgency } from './SupportTicket';

export interface CreateSupportTicketDTO {
  name: string;
  body: string;
  categoryID: number;
  urgency: SupportTicketUrgency;
  businessID?: number;
  startDate?: number;
  endDate?: number;
}

export const exampleCreateSupportTicketDTO: CreateSupportTicketDTO = {
  name: 'help plz',
  body: 'i am updating for faster help',
  categoryID: 2,
  urgency: SupportTicketUrgency.High,
};

export interface UpdateSupportTicketDTO {
  name?: string;
  body?: string;
  categoryID?: number;
}

export const exampleUpdateSupportTicketDTO: UpdateSupportTicketDTO = {
  name: 'hello world',
};
